/**
 * 「评估方法」抽屉
 *
 * 正文、引注、字段名全在 ./method.js，这里只负责摆开：文案改动不应该走组件 diff（R15），
 * 而 buildChecks.test.js 扫到本文件里有中文字面量就会红 —— 这是刻意的，逼着字待在一个文件。
 *
 * 2026-09-16 精简：原来顶上有一张"载荷形状 / 引擎版本 / 权重约定 / 输入摘要 / 追踪号"的表，
 * 那是给研发对账用的，运营看不懂也不会看，还把真正要看的几句顶到了屏幕外。已整块移除
 * （对账信息在服务端日志里，本来就不该由这个页面承担）。所以本组件现在不需要 profile。
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from 'antd';
import {
  METHOD_SECTIONS,
  CITATIONS,
  METHOD_FOOTNOTE,
  METHOD_UI,
} from './method';
import styles from './index.less';

export const MethodDrawer = React.memo(function MethodDrawer({
  visible,
  onClose,
}) {
  return (
    <Drawer
      title={METHOD_UI.title}
      placement="right"
      width={520}
      open={visible}
      onClose={onClose}
    >
      {METHOD_SECTIONS.map((section) => (
        <div key={section.key} className={styles.methodSection}>
          <div className={styles.methodSectionTitle}>{section.title}</div>
          {section.lines.map((line) => (
            <div key={line} className={styles.methodLine}>
              {METHOD_UI.bullet}
              {line}
            </div>
          ))}
        </div>
      ))}

      <div className={styles.methodSection}>
        <div className={styles.methodSectionTitle}>
          {METHOD_UI.citationsTitle}
        </div>
        {CITATIONS.map((item) => (
          <div key={item.id} className={styles.methodCite}>
            <div className={styles.methodCiteWork}>{item.work}</div>
            <div className={styles.methodLine}>
              {METHOD_UI.bullet}
              {item.usedFor}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.methodFootnote}>{METHOD_FOOTNOTE}</div>
    </Drawer>
  );
});

MethodDrawer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

MethodDrawer.defaultProps = {
  visible: false,
  onClose: () => {},
};

export default MethodDrawer;
